/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags.
 * These must be set before zone.js is loaded, so they live in their own module imported ahead of it.
 */

// (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
// (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
// (window as any).__zone_symbol__BLACK_LISTED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames
(window as any).__Zone_disable_Error = true; // Disable patching for Error

// zone.js's FileReader patch loses the methods of happy-dom's FileReader, so leave it unpatched there
if (/HappyDOM/.test(navigator.userAgent)) {
  (window as any).__Zone_disable_FileReader = true;
}

/*
 * in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
 * with the following flag, it will bypass `zone.js` patch for IE/Edge
 */
// (window as any).__Zone_enable_cross_context_check = true;
